import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  toast(
    type: "success" | "danger" | "warning" | "info",
    message: string,
    timer: number = 1500
  ) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: type === "danger" ? "error" : type,
      title: message,
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      // showClass: { popup: "animate__animated animate__fadeInRight" },
      // hideClass: { popup: "animate__animated animate__fadeOutRight" },
      customClass: {
        popup: `swal2-toast-custom no-shadow  toast-${type}`,
      },
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  toastSuccess(message: string, timer: number = 2000) {
    this.toast("success", message, timer);
  }
  toastError(message: string, timer: number = 2000) {
    this.toast("danger", message, timer);
  }
  toastWarning(message: string, timer: number = 2000) {
    this.toast("warning", message, timer);
  }
  toastInfo(message: string, timer: number = 2000) {
    this.toast("info", message, timer);
  }
}
